import { default as CookieDisclaimerModule } from "./cookie-disclaimer-module";
export { CookieDisclaimerModule };



// WEBPACK FOOTER //
// ./lib/ts/modules/cookieDisclaimer/index.ts